import { render, staticRenderFns } from "./riskProcessDetailPL.vue?vue&type=template&id=85a40e60&scoped=true"
import script from "./riskProcessDetailPL.vue?vue&type=script&lang=js"
export * from "./riskProcessDetailPL.vue?vue&type=script&lang=js"
import style0 from "./riskProcessDetailPL.vue?vue&type=style&index=0&id=85a40e60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a40e60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a40e60')) {
      api.createRecord('85a40e60', component.options)
    } else {
      api.reload('85a40e60', component.options)
    }
    module.hot.accept("./riskProcessDetailPL.vue?vue&type=template&id=85a40e60&scoped=true", function () {
      api.rerender('85a40e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/timeline/riskProcessDetailPL.vue"
export default component.exports